import { Injectable, inject } from '@angular/core';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { UserContextService } from './user-context.service';

const buildAuthConfig = (): AuthConfig => ({
  issuer: environment.keycloakUrl,
  redirectUri: window.location.origin,
  clientId: environment.keycloakClientId,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: !environment.production,
});

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly oauthService = inject(OAuthService);
  private readonly userCtxService = inject(UserContextService);

  async initialize(): Promise<void> {
    this.oauthService.configure(buildAuthConfig());
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();
    this.oauthService.setupAutomaticSilentRefresh();
    // Charger le UserContext si l'utilisateur est déjà authentifié
    if (this.isAuthenticated) {
      await this.userCtxService.loadUserContext();
    }
  }

  login(): void {
    this.oauthService.initCodeFlow();
  }

  logout(): void {
    this.oauthService.logOut();
  }

  get isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

  get identityClaims(): Record<string, unknown> | null {
    return this.oauthService.getIdentityClaims() as Record<string, unknown> | null;
  }
}
